/**
 * Master form entity keys (must match backend `MasterFormController` / `config/permissions.php`).
 */
export const MASTER_FORM_ENTITIES = [
  "schools",
  "genders",
  "regions",
  "formats",
  "target_schools",
  "days",
  "months",
  "weekdays",
  "years",
  "academic_years",
  "exam_boards",
  "weeks",
  "locations",
  "subjects",
  "topics",
  "sub_topics",
  "categories",
  // "roles" moved to its own section: /admin/roles (Roles & Permissions).
  "reference_books",
  "nvr_rules",
  "mobile_subscription_plans",
  "cancellation_reasons",
  "consortiums",
];

/** Permissions that allow opening the Master Forms admin route (any entity, any action). */
export function masterFormRoutePermissions() {
  const perms = [];
  for (const e of MASTER_FORM_ENTITIES) {
    perms.push(
      `view-master-form-${e}`,
      `create-master-form-${e}`,
      `update-master-form-${e}`,
      `delete-master-form-${e}`
    );
  }
  return perms;
}

export function masterFormPermission(verb, entity) {
  return `${verb}-master-form-${entity}`;
}
